import type { PrayerStatus, Priority } from '../domain.ts';
import { statusLabel, priorityLabel } from '../domain.ts';

/**
 * 상태·중요도 알약.
 *
 * 색을 직접 지정하지 않습니다. data-status / data-priority 를 달면
 * tokens.css 의 매핑이 --status-fg / --status-bg 를 채워 줍니다.
 * 팔레트를 바꿀 때 이 파일은 건드릴 필요가 없습니다.
 */

export function StatusPill({ status }: { status: PrayerStatus }) {
  return (
    <span className="pill pill--status" data-status={status}>
      <span className="pill__dot" />
      {statusLabel[status]}
    </span>
  );
}

export function PriorityPill({ priority }: { priority: Priority }) {
  return (
    <span className="pill pill--priority" data-priority={priority}>
      {priorityLabel[priority]}
    </span>
  );
}

export function GhostPill({ children }: { children: React.ReactNode }) {
  return <span className="pill pill--ghost">{children}</span>;
}
